import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, Col, Row } from "reactstrap";
import { renderCandidateMetadataToolbarFilterControl } from "helpers/GeneralHelper";
import { computeMetadataToolbarColumnLayout } from "helpers/metadataFilterHelpers";

/**
 * Upper filter row for metadata fields marked `isDefault: true`.
 * Column widths adapt to filter count and control types unless overridden.
 */
const MetadataFilterToolbar = ({
  toolbarDefinitions = [],
  listFilter = {},
  onTextChange,
  onSelectChange,
  onSearch,
  onClear,
  showClearWhenNoModalFilters = false,
  toolbarDropdownOptionsByFieldName = {},
  toolbarColumnMdLayout = null,
  layoutPreset = null,
  searchOnEnter = true,
  className = "metadata-filter-toolbar upper-filter-bar manage-user-filter-strip",
  pageName = "",
  remountKey = 0,
}) => {
  const resolvedColumnLayout = useMemo(
    () =>
      Array.isArray(toolbarColumnMdLayout) && toolbarColumnMdLayout.length
        ? toolbarColumnMdLayout
        : computeMetadataToolbarColumnLayout(toolbarDefinitions, { layoutPreset }),
    [toolbarColumnMdLayout, toolbarDefinitions, layoutPreset]
  );

  if (!toolbarDefinitions?.length) return null;

  const searchColMd = String(
    resolvedColumnLayout[toolbarDefinitions.length] ??
      resolvedColumnLayout[resolvedColumnLayout.length - 1] ??
      2
  );

  return (
    <div key={remountKey ? `metadata-filter-toolbar-${remountKey}` : undefined} className={className}>
      <Row className="metadata-filter-toolbar__row g-2 g-md-3 align-items-end">
        {toolbarDefinitions.map((filterDefinition, toolbarFilterColumnIndex) =>
          renderCandidateMetadataToolbarFilterControl(
            filterDefinition,
            toolbarFilterColumnIndex,
            listFilter,
            onTextChange,
            onSelectChange,
            onSearch,
            toolbarDropdownOptionsByFieldName,
            resolvedColumnLayout,
            searchOnEnter,
            pageName
          )
        )}
        <Col
          xs="12"
          md={searchColMd}
          lg={searchColMd}
          className="metadata-filter-field metadata-filter-field--actions"
        >
          <span className="manage-user-filter-label" aria-hidden="true">
            &nbsp;
          </span>
          <div className="metadata-filter-toolbar__actions d-flex flex-column flex-sm-row gap-2">
            <Button
              color="primary"
              className="w-100 manage-user-search-btn"
              type="button"
              onClick={onSearch}
            >
              <i className="fa fa-search me-1" aria-hidden="true" />
              Search
            </Button>
            {showClearWhenNoModalFilters ? (
              <Button
                color="light"
                className="w-100 border metadata-filter-toolbar__clear-btn"
                type="button"
                onClick={onClear}
              >
                Clear filters
              </Button>
            ) : null}
          </div>
        </Col>
      </Row>
    </div>
  );
};

MetadataFilterToolbar.propTypes = {
  toolbarDefinitions: PropTypes.array,
  listFilter: PropTypes.object,
  onTextChange: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  showClearWhenNoModalFilters: PropTypes.bool,
  toolbarDropdownOptionsByFieldName: PropTypes.object,
  toolbarColumnMdLayout: PropTypes.arrayOf(PropTypes.number),
  layoutPreset: PropTypes.string,
  searchOnEnter: PropTypes.bool,
  className: PropTypes.string,
  pageName: PropTypes.string,
  remountKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default MetadataFilterToolbar;
